/* eslint-disable react/prop-types */
import React from 'react'
// import { useSvg } from 'irmlib/hooks'

/**
 * @function
 * @description CSV Import Icon
 * @returns {object} svg of the icon
 */
const CSVImportIcon = () => {
  // const iconWidth = 22
  // const iconHeight = 22
  // const [, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.725" height="21.725" viewBox="0 0 21.725 21.725">
      <g id="Group_2486" data-name="Group 2486" transform="translate(-10901.336 18393.652)">
        <g id="Boundary" transform="translate(10901.336 -18393.652)" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="21.725" height="21.725" stroke="none" />
          <rect x="0.5" y="0.5" width="20.725" height="20.725" fill="none" />
        </g>
        <path id="Path_file-delimited" data-name="Path / file-delimited" d="M13.052,2H5.81A1.816,1.816,0,0,0,4,3.81V18.293A1.816,1.816,0,0,0,5.81,20.1H16.673a1.816,1.816,0,0,0,1.81-1.81V7.431L13.052,2m-.905,6.336V3.358l4.979,4.979Z" transform="translate(10900.957 -18393.842)" fill="#1b75bc" />
        <text id="CSV" transform="translate(10907.862 -18377.137)" fill="#fff" fontSize="5" fontFamily="Roboto-Bold, Roboto" fontWeight="700"><tspan x="0" y="0">CSV</tspan></text>
      </g>
    </svg>

  )
}

export default CSVImportIcon